import { render, staticRenderFns } from "./commonPage.vue?vue&type=template&id=0fe176d6"
import script from "./commonPage.vue?vue&type=script&lang=js"
export * from "./commonPage.vue?vue&type=script&lang=js"
import style0 from "./commonPage.vue?vue&type=style&index=0&id=0fe176d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports